<template>
  <div class="home">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-home">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{ $t("home.aa") }}</span>
            </div>
          </div>
          <div class="home-container clearFloat">
            <div class="leftBox pull-left">
              <div class="dt-box">
                <div class="top-tab">
                  <div class="top-title-model text-3 clearFloat">
                    <span class="h3">{{ $t("home.ab") }}</span>
                  </div>
                  <el-row class="conut-briefing">
                    <el-col
                      v-for="(item, index) in conutInfo"
                      :key="index"
                      :span="spanWidth"
                    >
                      <div
                        class="grid-content bg-purple"
                        @click="postbeCrmlevel != 3 ? ClickTab(item) : ''"
                        style="display: flex; align-items: center"
                      >
                        <div class="img-container">
                          <img :src="item.imgurl" />
                        </div>
                        <div class="text" style="text-align: left">
                          <div>
                            {{ item.text }}
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="item.content"
                              placement="top"
                            >
                              <em class="el-icon-warning"></em>
                            </el-tooltip>
                          </div>
                          <div class="num">{{ item.num }}</div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <!-- <div class="dt-box" v-if="!IsLowerLevel">
                <div class="top-tab">
                  <div class="top-title-model text-3 clearFloat">
                    <span class="h3">{{ $t("home.gmcRosterTitle") }}</span>
                  </div>

                  <div class="gmc-roster">
                    <div class="filter-box" v-if="!IsLowerLevel">
                      <el-select
                        clearable
                        @change="getTmkClientRemindApi"
                        :placeholder="$t('home.gmcRosterPlaceholder')"
                        v-model="gmcRosterData.filterValue"
                      >
                        <el-option
                          v-for="(item, index) in gmcRosterData.filterList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <el-tabs
                      v-model="gmcRosterActive"
                      @tab-click="handleGmcClick"
                    >
                      <el-tab-pane
                        :label="$t('home.gmcRosterTab1')"
                        name="zero"
                      >
                        <p
                          class="gmc-roster__tips"
                          v-if="gmcRosterData.showGmcTitle"
                        >
                          <em
                            class="el-icon-warning"
                            style="color: #00addf"
                          ></em>
                          {{ $t("home.gmcRosterTip") }}
                          <i
                            class="el-icon-close"
                            style="color: #666"
                            @click="gmcRosterData.showGmcTitle = false"
                          ></i>
                        </p>

                        <el-row class="resoter-list">
                          <el-col
                            class="roster-item"
                            v-for="(item, index) in gmcRosterData.all"
                            :key="index"
                          >
                            <div
                              class="roster-item__header"
                              @click="handleCheckDesc(item)"
                            >
                              <div class="user">
                                <img
                                  v-if="item.client_img"
                                  :src="item.client_img"
                                />
                                <img
                                  v-else-if="item.client_sex == '男'"
                                  src="@/assets/images/default-img-man.png"
                                  alt
                                />
                                <img
                                  v-else-if="item.client_sex == '女'"
                                  src="@/assets/images/default-img-women.png"
                                  alt
                                />
                                <span
                                  >{{ item.client_cnname }}
                                  {{ item.client_enname }}</span
                                >
                              </div>
                              <div class="status">
                                <span class="status-item status-item-green">{{
                                  item.client_tracestatus
                                }}</span>
                                <span class="status-item status-item-pink">{{
                                  item.client_distributionstatus_name
                                }}</span>
                              </div>
                            </div>
                            <div
                              class="roster-item__desc"
                              @click="handleCheckDesc(item)"
                            >
                              {{ item.track_note }}
                            </div>
                            <p class="time">{{ item.client_createtime }}</p>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div> -->
              <div class="dt-box">
                <div class="top-tab">
                  <div class="top-title-model text-3 clearFloat">
                    <span class="h3">{{ $t("home.ac") }}</span>
                    <a
                      href="javascript:;"
                      v-for="(item, index) in toptabcont"
                      :key="item"
                      :class="{
                        'tab-active':
                          index == current ||
                          (current == index + 1 && index == 2),
                      }"
                      class="tab-gray-mini text-3 button-fiter"
                      @click="addClass(index)"
                      >{{ item }}</a
                    >
                    <el-date-picker
                      v-model="datetime"
                      type="daterange"
                      @focus="dateClass(2)"
                      @change="getTimeDate"
                      :range-separator="$t('home.ad')"
                      :start-placeholder="$t('home.a1')"
                      :end-placeholder="$t('home.ae')"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    <span v-if="showHightTime" class="hight-time">{{
                      hightTime
                    }}</span>
                    <el-select
                      filterable
                      clearable
                      v-model="schoolvalue1"
                      :placeholder="$t('home.af')"
                      class="select-school pull-right"
                      @change="handleSelect1()"
                      v-if="!IsLowerLevel"
                    >
                      <el-option
                        v-for="(item, $index) in schoolList"
                        :key="$index"
                        :label="`${item.marketer_name} ${
                          item.staffer_enname
                            ? '(' + item.staffer_enname + ')'
                            : ''
                        }`"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="admissions-briefing">
                    <!-- <div
                      class="item-briefing"
                      v-for="item in arr"
                      :key="item.value"
                      :class="{ 'el-row-last': item.isLast }"
                    >
                      <img v-bind:src="item.img" alt />
                      <div>
                        <p class="text-1 top-title font-333">
                          {{ item.title }}
                        </p>
                        <p class="h3 top-number">
                          {{ item.num }} {{ $t("Common.person") }}
                        </p>
                      </div>
                    </div> -->
                    <el-row class="conut-briefing" style="width: 100%">
                      <el-col
                        v-for="(item, index) in arr.filter(
                          (item) => !item.hide
                        )"
                        :key="index"
                        :span="spanWidth"
                      >
                        <div
                          class="grid-content bg-purple"
                          style="display: flex; align-items: center"
                        >
                          <div class="img-container">
                            <img :src="item.img" />
                          </div>
                          <div class="text" style="text-align: left">
                            <div>
                              {{ item.title }}
                            </div>
                            <div class="num">{{ item.num }}</div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="dt-box">
                <div class="top-tab">
                  <div class="top-title-model clearFloat">
                    <span class="h3">{{ $t("home.ag") }}</span>
                    <el-select
                      clearable
                      filterable
                      v-model="schoolvalue2"
                      :placeholder="$t('home.af')"
                      class="select-school pull-right"
                      @change="handleSelect2()"
                      v-if="!IsLowerLevel"
                    >
                      <el-option
                        v-for="(item, $index) in schoolRateList"
                        :key="$index"
                        :label="`${item.marketer_name} ${
                          item.staffer_enname
                            ? '(' + item.staffer_enname + ')'
                            : ''
                        }`"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="dt-box-contain funnel-contain">
                    <div
                      id="myChart-funnel"
                      :style="{ width: '450px', height: '300px' }"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="dt-box">
                <div class="top-tab">
                  <div class="top-title-model clearFloat">
                    <span class="h3">{{ $t("home.ai") }}</span>
                    <el-select
                      clearable
                      filterable
                      v-model="schoolvalue3"
                      :placeholder="$t('home.af')"
                      class="select-school pull-right"
                      @change="handleSelect3()"
                      v-if="!IsLowerLevel"
                    >
                      <el-option
                        v-for="(item, $index) in schoolClueList"
                        :key="$index"
                        :label="`${item.marketer_name} ${
                          item.staffer_enname
                            ? '(' + item.staffer_enname + ')'
                            : ''
                        }`"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="dt-box-contain text-1 List-clues">
                    <el-row>
                      <el-col :span="16">
                        <span class="list1 list">1</span>
                        <span>毛名单转化为意向客户数量/转化率</span>
                      </el-col>
                      <el-col :span="8">{{ rateList.maoToYiRate }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="16">
                        <span class="list2 list">2</span>
                        <span>意向客户转化为试听客户数量/转化率</span>
                      </el-col>
                      <el-col :span="8">{{ rateList.yiToShiRate }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="16">
                        <span class="list3 list">3</span>
                        <span>意向客户转化为正式客户数量/转化率</span>
                      </el-col>
                      <el-col :span="8">{{ rateList.yiToZhengRate }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="16">
                        <span class="list4 list">4</span>
                        <span>毛名单转化为无效客户数量/转化率</span>
                      </el-col>
                      <el-col :span="8">{{ rateList.maoToWuRate }}</el-col>
                    </el-row>
                    <!-- <el-row v-if="companyIsNoIntention">
                      <el-col :span="16">
                        <span class="list5 list">5</span>
                        {{ $t("home.an") }}
                      </el-col>
                      <el-col :span="8">
                        {{ rateList.loseClient }}/{{ rateList.addClient }}({{
                          rateList.loseClientRate
                        }}%)
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="16">
                        <span class="list5 list">{{ companyIsNoIntention ? 6 : 5 }}</span>
                        有效名单转无效客户数量/转化率
                      </el-col>
                      <el-col :span="8">
                        {{ rateList.invalidClient }}/{{ rateList.addClient }}({{
                          rateList.invalidClientRate
                        }}%)
                      </el-col>
                    </el-row> -->
                  </div>
                </div>
              </div>
              <div class="dt-box">
                <div class="top-tab">
                  <div class="top-title-model clearFloat">
                    <span class="h3">{{ $t("home.cf") }}</span>
                  </div>
                </div>
                <div class="mt20 mb20">
                  <el-date-picker
                    v-model="performanceFilter.date"
                    type="daterange"
                    @change="getSchMarketerEnrollApi"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    style="width: 260px"
                    class="mr10"
                  >
                  </el-date-picker>
                  <el-select
                    clearable
                    filterable
                    v-model="performanceFilter.coursetype_id"
                    :placeholder="$t('home.cg')"
                    class="select-school"
                    @change="getSchMarketerEnrollApi"
                  >
                    <el-option
                      v-for="(item, index) in performanceFilter.coursetypeList"
                      :key="index"
                      :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                      :value="item.coursetype_id"
                    ></el-option>
                  </el-select>
                </div>
                <normalTableCont :tableData="tableList"></normalTableCont>
              </div>
            </div>
            <div class="rightBox pull-right">
              <div class="dt-box">
                <div class="top-title-model clearFloat">
                  <span class="h3">{{ $t("home.ao") }}</span>
                  <a
                    class="text-3 pull-right font-blue"
                    style="cursor: pointer"
                    @click="handClickmore()"
                    >{{ $t("home.ap") }}&gt;&gt;</a
                  >
                </div>
                <div class="dt-box-contain text-1 remind">
                  <el-row v-for="(items, index) in RemindData" :key="index">
                    <el-col :span="8">
                      <span class="remind-tab text-1">
                        <i class="el-icon-time h1"></i>
                        {{ items.remind_time }}
                      </span>
                      <template v-if="items.isTrack == '1'">
                        <div class="remind-status nostatus text-3">
                          {{ $t("home.aq") }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="remind-status text-3">
                          {{ $t("home.ar") }}
                        </div>
                      </template>
                    </el-col>
                    <el-col :span="16">
                      <div class="remind-cont">
                        <p>
                          <span class="name">
                            <i
                              @click="handClickName(items)"
                              style="font-style: normal; cursor: pointer"
                              >{{ items.client_cnname }}</i
                            >
                            <img
                              v-if="items.client_sex == `${$t('Common.man')}`"
                              :src="iconmen"
                            />
                            <img
                              v-if="items.client_sex == `${$t('Common.woman')}`"
                              :src="iconWommen"
                            />
                          </span>
                          <span
                            >{{ items.client_age }}{{ $t("Common.age") }}</span
                          >
                          <span
                            >{{ $t("home.aq") }}{{ items.trackNum
                            }}{{ $t("Common.times") }}</span
                          >
                        </p>
                        <p class="small-tip">
                          {{ $t("home.aw") }}{{ items.lastTrackTime }}
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                  <p v-if="RemindDatalen == 0" class="no-data">
                    <i class="crm-wu"></i>
                    {{ $t("home.as") }}
                  </p>
                </div>
              </div>
              <div class="dt-box">
                <div class="top-title-model">
                  <!-- <span class="h3">待办事项</span> -->
                </div>
                <div class="dt-box-contain">
                  <Calendar
                    :calendar="calendar"
                    @handSeeEvent="handSeeEvent"
                  ></Calendar>
                </div>
              </div>
              <div class="dt-box" v-if="!IsLowerLevel">
                <div class="top-tab">
                  <div class="top-title-model text-3 clearFloat">
                    <span class="h3">{{ $t("home.gmcRosterTitle") }}</span>
                  </div>

                  <div class="gmc-roster">
                    <div class="filter-box" v-if="!IsLowerLevel">
                      <el-select
                        clearable
                        @change="getTmkClientRemindApi"
                        :placeholder="$t('home.gmcRosterPlaceholder')"
                        v-model="gmcRosterData.filterValue"
                      >
                        <el-option
                          v-for="(item, index) in gmcRosterData.filterList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <el-tabs
                      v-model="gmcRosterActive"
                      @tab-click="handleGmcClick"
                    >
                      <el-tab-pane
                        :label="$t('home.gmcRosterTab1')"
                        name="zero"
                      >
                        <p
                          class="gmc-roster__tips"
                          v-if="gmcRosterData.showGmcTitle"
                        >
                          <em
                            class="el-icon-warning"
                            style="color: #00addf"
                          ></em>
                          {{ $t("home.gmcRosterTip") }}
                          <i
                            class="el-icon-close"
                            style="color: #666"
                            @click="gmcRosterData.showGmcTitle = false"
                          ></i>
                        </p>

                        <el-row
                          class="resoter-list"
                          v-if="gmcRosterData.all.length > 0"
                        >
                          <el-col
                            class="roster-item"
                            v-for="(item, index) in gmcRosterData.all"
                            :key="index"
                          >
                            <div
                              class="roster-item__header"
                              @click="handleCheckDesc(item)"
                            >
                              <div class="user">
                                <img
                                  v-if="item.client_img"
                                  :src="item.client_img"
                                />
                                <img
                                  v-else-if="item.client_sex == '男'"
                                  src="@/assets/images/default-img-man.png"
                                  alt
                                />
                                <img
                                  v-else-if="item.client_sex == '女'"
                                  src="@/assets/images/default-img-women.png"
                                  alt
                                />
                                <span
                                  >{{ item.client_cnname }}
                                  {{ item.client_enname }}</span
                                >
                              </div>
                              <div class="status">
                                <span class="status-item status-item-green">{{
                                  item.client_tracestatus
                                }}</span>
                                <span class="status-item status-item-pink">{{
                                  item.client_distributionstatus_name
                                }}</span>
                              </div>
                            </div>
                            <div
                              class="roster-item__desc"
                              @click="handleCheckDesc(item)"
                            >
                              {{ item.track_note }}
                            </div>
                            <p class="time">{{ item.client_createtime }}</p>
                          </el-col>
                        </el-row>
                        <p v-else class="no-data pt20 fs14">
                          <i class="crm-wu"></i>
                          {{ $t("home.cc") }}
                        </p>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- //侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBox"
      @hideSliderBox="hideSliderBox"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain slider-home">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">{{ $t("home.at") }}</p>
          <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
            <i class="el-icon-close"></i>
          </div>
          <!-- <el-button type="primary" class="pull-right">确定</el-button> -->
        </div>
        <div class="slider-cont text-1">
          <el-form ref="selectForm" :model="selectForm" class="remind-form">
            <el-form-item :label="$t('Common.keyWord')" label-width="70px">
              <el-input
                clearable
                v-model="selectForm.keyword"
                style="width: 160px"
                :placeholder="$t('home.av')"
                @change="SelectKeyword"
              >
                <i
                  slot="suffix"
                  class="el-icon-search"
                  style="cursor: pointer"
                  @click="SelectKeyword"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('home.aww')"
              label-width="90px"
              style="margin-left: 8px"
            >
              <el-date-picker
                v-model="selectForm.remind_starttime"
                style="width: 140px"
                type="date"
                :placeholder="$t('Common.startTime')"
                value-format="yyyy-MM-dd"
                @change="SelectStarttime"
              ></el-date-picker>
              <span>{{ $t("Common.to") }}</span>
              <el-date-picker
                v-model="selectForm.remind_endtime"
                style="width: 140px"
                type="date"
                :placeholder="$t('Common.endTime')"
                value-format="yyyy-MM-dd"
                @change="SelectEndtime"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <tipsTable
            :list="tryRecordlist"
            :options="recordoptions"
            :columns="recordlistColumn"
            :operates="recordOperates"
            @handleColumnChange="handleColumnChange"
          ></tipsTable>
          <el-pagination
            style="margin-top: 35px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dataNumber"
          ></el-pagination>
        </div>
      </div>
    </SliderBox>

    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :iscanEdit="false"
        isHome="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
      ></userSeeing>
    </SliderBox>

    <slider-box
      :showSliderBox="showLSSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <schoolSeeing
        :showUserSliderBox="showLSSliderBoxSee"
        :customerId="customerId"
        :sId="sId"
        :sType="sType"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :activeName="activeName"
        :isRoot="isRoot"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @handleSliderClick="handleSliderClick"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :campusrosterStuData="campusrosterStuData"
        :studentType="studentType"
        :fromCrmIndex="true"
        @updateList="getCrmStudentOneApi(customerId)"
      ></schoolSeeing>
    </slider-box>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
    ></auditClass>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import Calendar from "@/components/Calendar/Calendar.vue";
import SliderBox from "@/components/SliderBox";
import tipsTable from "@/components/Table/tipsTable.vue";
import userSeeing from "@/components/User/seeing.vue";
import auditClass from "@/components/Class/Class.vue";
import schoolSeeing from "@/components/User/schoolSeeing.vue";
import normalTableCont from "@/components/tables/normalTableCont";

import echarts from "echarts";
import storeHome from "./home.js";
export default {
  name: "Home-home",
  data() {
    return {
      spanWidth: 6,
      postbeCrmlevel: "",
      sId: "",
      sType: "",
      studentType: "",
      campusrosterStuData: null,
      activeName: "first",
      showLSSliderBoxSee: false,

      openMenu: ["0"],
      gmcRosterActive: "zero",
      gmcRosterData: {
        all: [],
        filterValue: "",
        showGmcTitle: true,
        filterList: [
          {
            value: "",
            label: this.$t("Customersmanage.br"),
          },
          {
            value: "0",
            label: this.$t("Customersmanage.bs"),
          },
          {
            value: "1",
            label: this.$t("Customersmanage.bt"),
          },
          {
            value: "2",
            label: this.$t("Customersmanage.bu"),
          },
          {
            value: "3",
            label: this.$t("Customersmanage.bv"),
          },
          // // 未柜询
          // {
          //   value: "6",
          //   label: this.$t("Customersmanage.bvN1"),
          // },
          // // 未试听
          // {
          //   value: "7",
          //   label: this.$t("Customersmanage.bvN2"),
          // },
          {
            value: "8",
            label: this.$t("Customersmanage.bvN3"),
          },
          {
            value: "9",
            label: this.$t("Customersmanage.bvN4"),
          },
        ],
      },
      current: 0,
      showSliderBox: false,
      isPagination: false, //是否有分页
      fullscreenLoading: true, //全屏loading
      // 分页的数据
      dataNumber: 0, //数据总数
      ClassMessage: {}, //选择的试听班级
      pagenum: 10,
      currentPage: 1,
      pagesize: 10,
      leaningVisible: false,
      showSliderBoxSee: false,
      createJG: false,
      seeSliderTitle: "",
      isTrack: false, //是否点击跟进
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      isRoot: false,
      showHightTime: false, //是否高级筛选显示时间
      customerId: "",
      hightTime: "",
      sliderWidth: "700px",
      schoolvalue1: "", //职工筛选
      schoolvalue2: "", //职工筛选
      schoolvalue3: "", //职工筛选
      datetime: "",
      calendar: false,
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      //筛选条件
      selectForm: {
        remind_starttime: "",
        remind_endtime: "",
        keyword: "",
      },
      form: {
        name: "",
        startTime: "",
        endTime: "",
      },
      toptabcont: this.$t("home.bb"), //存储筛选条件
      arr: [], //存放转化后的招生统计数据
      dateArr: [],
      rateList: [], //存储转化率
      clueList: [], //存储转化率(漏斗图)
      ChangeUrl: [],
      // 统计信息
      conutInfo: [],
      staticsFliter: {
        client_starttime: this.$Common.getDate(-7),
        client_endtime: this.$Common.getDate(0),
      },
      Statistics: [
        {
          id: "1",
          img: require("../../assets/images/home-top-tab1.png"),
          url: "/Admissioncue/admissionCue",
          title: this.$t("home.ca"),
          isLast: false,
        },
        // {
        //   id: "2",
        //   img: require("../../assets/images/home-top-tab2.png"),
        //   title: this.$t("home.cb"),
        //   url: "/Customersmanage/custoMersmanage",
        //   isLast: false,
        // },
        {
          id: "3",
          img: require("../../assets/images/home-top-tab3.png"),
          title: this.$t("home.cd"),
          url: "/Losscustomermanage/losscustomerManage",
          isLast: false,
        },
        {
          id: "4",
          img: require("../../assets/images/home-top-tab4.png"),
          title: this.$t("home.ce"),
          url: "/Invitationauditionmanage/invitationManage",
          isLast: true,
        },
        // {
        //   id: "5",
        //   img: require("../../assets/images/home-top-tab5.png"),
        //   title: this.$t("home.bg"),
        //   url: "/Invitationauditionmanage/auditionManage",
        //   isLast: false
        // },
        // {
        //   id: "6",
        //   img: require("../../assets/images/home-top-tab6.png"),
        //   title: this.$t("home.bh"),
        //   url: "/Registeredlist/registeredList",
        //   isLast: true
        // }

        {
          id: "5",
          img: "https://pic.kedingdang.com/schoolmanage/crmhomeicons/count7.png",
          title: "累计邀约试听名单",
          url: "/Invitationauditionmanage/auditionManage",
          isLast: true,
          hide: true,
        },
        {
          id: "6",
          img: "https://pic.kedingdang.com/schoolmanage/crmhomeicons/count8.png",
          title: "累计转正人数",
          url: "/Invitationauditionmanage/auditionManage",
          isLast: true,
          hide: true,
        },
        {
          id: "7",
          img: require("../../assets/images/home-top-tab2.png"),
          title: "新增无效客户",
          url: "/Customersmanage/custoMersmanage",
          isLast: false,
        },
      ], //存放招生统计数据
      schoolList: [],
      schoolRateList: [],
      schoolClueList: [],
      RemindData: [], //存放跟踪提醒数据
      RemindDatalen: 0,
      tryRecordlist: [],
      columnWidth: ["auto", "80", "100", "110", "90", "135", "135"],
      recordlistColumn: [],
      recordoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: "",
      },
      recordOperates: {
        width: 200,
        label: this.$t("home.bi"),
        align: "center",
        fixed: "right",
        list: [],
      },
      performanceFilter: {
        end_time: "",
        coursetype_id: "",
        date: [],
        coursetypeList: [],
      },
      // 主表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 290,
        },
      },
    };
  },
  watch: {},
  components: {
    PageNav,
    SliderBox,
    tipsTable,
    userSeeing,
    auditClass,
    Calendar,
    schoolSeeing,
    normalTableCont,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // this.school_id = this.$Tool.getStorage("school_id");
    this.performanceFilter.end_time = this.$Common.getDateStr3(new Date());
    //默认显示7天内的数据
    this.performanceFilter.date = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getDateStr3(new Date()),
    ];

    let client_starttime = this.$Common.getDate(0);
    let client_endtime = this.$Common.getDate(-7);
    // this.schoolvalue=this.school_id;
    let data = {
      marketer_id: this.marketer_id,
      token: this.token,
      company_id: this.company_id,
      school_id: this.school_id,
      client_starttime: client_endtime,
      client_endtime: client_starttime,
    };

    this.rateGet(data);
    //本周待跟踪提醒
    var currentTime = this.getWeekStartAndEnd(0);
    let data2 = {
      marketer_id: this.marketer_id,
      token: this.token,
      company_id: this.company_id,
      school_id: this.school_id,
      remind_starttime: currentTime[0],
      remind_endtime: currentTime[1],
      keyword: "",
    };
    this.courseTypeRecruitApi();
    this.getTmkClientRemindApi();
    this.getRemindDate(data2);
    this.getschoolMarketerData();
    this.getEnrollStuCountApi(); //首页->人数统计
    this.recordoptions.tableHeight = this.$Common.getTableHeight(300); //设置表格高度
    this.getSchMarketerEnrollApi();
  },
  mounted() {
    // this.canvasWidth();
    // this.funnelCanvas();
    this.spanWidth = window.innerWidth > 1200 ? 6 : 12;
    window.addEventListener(
      "resize",
      () => {
        this.spanWidth = window.innerWidth > 1200 ? 6 : 12;
      },
      false
    );

    this.postbeCrmlevel = this.$store.state.POSTBE_CRMLEVEL;
  },

  methods: {
    courseTypeRecruitApi() {
      storeHome
        .courseTypeRecruitApi({ coursetype_isrecruit: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.performanceFilter.coursetypeList = res.data.data.list;
          } else {
            this.performanceFilter.coursetypeList = [];
          }
        });
    },
    getSchMarketerEnrollApi() {
      storeHome
        .getSchMarketerEnrollApi({
          start_time: this.performanceFilter.date
            ? this.performanceFilter.date[0]
            : " ",
          end_time: this.performanceFilter.date
            ? this.performanceFilter.date[1]
            : " ",
          coursetype_id: this.performanceFilter.coursetype_id,
        })
        .then((res) => {
          this.tableList.columns = [];
          this.tableList.list = [];
          this.$nextTick(() => {
            const { msg, data: body } = res.data;
            const { list, field } = body;
            this.tableList.columns = field;
            this.tableList.list = list ? list : [];
            // this.paging.total = Number(all_num);
            this.tableList.options.errortip = msg;
          });
        });
    },
    handleSliderClick(v) {
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    getTmkClientRemindApi() {
      storeHome
        .getTmkClientRemindApi({
          client_tracestatus: this.gmcRosterData.filterValue,
        })
        .then((res) => {
          const { code, data: body } = res.data;
          if (code === 200) {
            this.gmcRosterData.all = body.data;
          }
        });
    },
    handleGmcClick(tab, event) {
      (() => {})(tab, event, this.gmcRosterActive);
    },
    //首页->人数统计
    getEnrollStuCountApi() {
      storeHome
        .getEnrollStuCountApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            let data = res.data.data;
            // let arr = [];
            // let obj1 = {
            //     text: data.field.clientgross_num,
            //     num: data.data.clientgross_num,
            //     url: "/ListAllocationManagement/grossList",
            //     content: '显示所有待筛选毛名单数'
            //   },
            //   obj2 = {
            //     text: data.field.client_num,
            //     num: data.data.client_num,
            //     url: "/ListAllocationManagement/preSetValidList",
            //     content: '显示所有待分配有效名单数'
            //   },
            //   obj3 = {
            //     text: data.field.intention_num,
            //     num: data.data.intention_num,
            //     url: "/Customersmanage/custoMersmanage",
            //     content: '普通权限显示我的意向客户总数，TMK和高管权限显示所有意向客户总数'
            //   },
            //   obj4 = {
            //     text: data.field.notrack_principalNum,
            //     num: data.data.notrack_principalNum,
            //     url: "/Customersmanage/custoMersmanage?client_tracestatus=0",
            //     content: '普通权限显示我的意向客户待跟踪数，TMK权限显示我的待跟踪毛名单数，高管权限显示所有待跟踪意向客户数'
            //   },
            //   obj5 = {
            //     text: data.field.seven_notrack_num,
            //     num: data.data.seven_notrack_num,
            //     url: "/Customersmanage/custoMersmanage?client_tracestatus=0",
            //     content: '普通权限显示我的7日未跟踪意向客户数，TMK权限显示我的7日未跟踪毛名单数，高管权限显示所有7日未跟踪意向客户数'
            //   },
            //   obj6 = {
            //     text: data.field.all_islossNum,
            //     num: data.data.all_islossNum,
            //     url: "/Losscustomermanage/losscustomerManage",
            //     content: '显示所有待审核无意向名单总数'
            //   },
            //   obj7 = {
            //     text: data.field.moth_auditionNum,
            //     num: data.data.moth_auditionNum,
            //     url: "/Invitationauditionmanage/auditionManage",
            //     content: '显示本月累计邀约试听名单记录'
            //   },
            //   obj8 = {
            //     text: data.field.moth_positiveNum,
            //     num: data.data.moth_positiveNum,
            //     url: "/Registeredlist/registeredList",
            //     content: '显示本月累计转正名单数'
            //   };

            // arr.push(obj1);
            // arr.push(obj2);
            // arr.push(obj3);
            // arr.push(obj4);
            // arr.push(obj5);
            // arr.push(obj6);
            // arr.push(obj7);
            // arr.push(obj8);

            // this.conutInfo = [];
            // this.conutInfo = arr;
            // (() => {})(arr);
            this.conutInfo = data.datanow;
          } else {
            this.conutInfo = [];
          }
        });
    },
    //获取当前时间和之前时间
    getDate(day) {
      var date1 = new Date();
      // time1 =
      //   date1.getFullYear() +
      //   "-" +
      //   (date1.getMonth() + 1) +
      //   "-" +
      //   date1.getDate(); //time1表示当前时间
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + day);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
      (() => {})(time2);
      return time2;
    },
    //获取当前日期yy-mm-dd
    //date 为时间对象
    getDateStr3(date) {
      var year = "";
      var month = "";
      var day = "";
      var now = date;
      year = "" + now.getFullYear();
      if (now.getMonth() + 1 < 10) {
        month = "0" + (now.getMonth() + 1);
      } else {
        month = "" + (now.getMonth() + 1);
      }
      if (now.getDate() < 10) {
        day = "0" + now.getDate();
      } else {
        day = "" + now.getDate();
      }
      return year + "-" + month + "-" + day;
    },
    //获取当前周
    getWeekStartAndEnd(AddWeekCount) {
      //起止日期数组
      var startStop = new Array();
      //一天的毫秒数
      var millisecond = 1000 * 60 * 60 * 24;
      //获取当前时间
      var currentDate = new Date();
      //相对于当前日期AddWeekCount个周的日期
      currentDate = new Date(
        currentDate.getTime() + millisecond * 7 * AddWeekCount
      );
      //返回date是一周中的某一天
      var week = currentDate.getDay();
      //返回date是一个月中的某一天
      // var month = currentDate.getDate();
      //减去的天数
      var minusDay = week != 0 ? week - 1 : 6;
      //获得当前周的第一天
      var currentWeekFirstDay = new Date(
        currentDate.getTime() - millisecond * minusDay
      );
      //获得当前周的最后一天
      var currentWeekLastDay = new Date(
        currentWeekFirstDay.getTime() + millisecond * 6
      );
      //添加至数组
      startStop.push(this.getDateStr3(currentWeekFirstDay));
      startStop.push(this.getDateStr3(currentWeekLastDay));

      return startStop;
    },
    getChangeUrl(url) {
      let urlLink = url.split("?")[0] ? url.split("?")[0] : url;
      storeHome
        .ChangeUrl({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          url: urlLink,
        })
        .then((res) => {
          const { code, msg, data } = res.data;
          if (code === 200) {
            const module = data.module;
            const tree = data.children;
            this.$Tool.setStorage("module_id", module.module_id);
            this.$store.dispatch("setModuleId", module.module_id);
            tree.forEach((item) => {
              item.children.forEach((item1) => {
                if (item1.module_markurl == urlLink) {
                  this.$Tool.setStorage("sliderActiveIndex", item1.activeIndex);
                  this.$store.dispatch("setActiveIndex", item1.activeIndex);
                  this.$Tool.setStorage("openMenu", ["" + item.index]);
                  this.$store.dispatch("setOpenMenu", ["" + item.index]);
                  this.$router.push(url);
                }
              });
            });
            (() => {})(module);
            (() => {})(data);
          } else {
            this.$message.error(msg);
          }
        });
    },
    ClickTab(v) {
      (() => {})(v);
      this.getChangeUrl(v.url);
      // this.$router.push(v.url);
    },
    //招生统计 / 转化 / 转化率接口请求
    rateGet(param) {
      storeHome.getConversion(param).then((res) => {
        let $data = res.data.data.data;
        this.rateList = res.data.data.data;
        this.clueList = res.data.data.data;
        if ($data != undefined) {
          (() => {})(this.Statistics, "this.Statistics -- this.Statistics");
          this.Statistics.forEach((item, index) => {
            switch (index) {
              case 0:
                item.num = $data.addGrossClient;
                break;
              // case 1:
              //   item.num = $data.loss_confirmClientNum;
              //   break;
              case 1:
                item.num = $data.yaoyueClient;
                break;
              case 2:
                item.num = $data.zhengshiClient;
                break;
              case 3:
                item.num = $data.all_auditionNum;
                break;
              case 4:
                item.num = $data.all_positiveNum;
                break;
              case 5:
                item.num = $data.wuxiaoClient;
                break;
              default:
                break;
            }
          });
        }

        this.arr = this.Statistics;
        this.canvasWidth();
        this.funnelCanvas();
      });
    },
    //招生统计 / 转化 / 转化率筛选
    SelectrateGet(type, value) {
      storeHome
        .getConversion({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_starttime: this.staticsFliter.client_starttime,
          client_endtime: this.staticsFliter.client_endtime,
          from_marketer_id: value,
        })
        .then((res) => {
          let $data = res.data.data.data;
          if (type == 1) {
            if ($data != undefined) {
              this.Statistics.forEach((item, index) => {
                switch (index) {
                  case 0:
                    item.num = $data.notrack_principalnum;
                    break;
                  // case 1:
                  //   item.num = $data.loss_confirmClientNum;
                  //   break;
                  case 1:
                    item.num = $data.all_invite_auditionNum;
                    break;
                  case 2:
                    item.num = $data.officialClient;
                    break;
                  case 3:
                    item.num = $data.inviteClient;
                    break;
                  case 4:
                    item.num = $data.officialClient;
                    break;
                  default:
                    (() => {})("error");
                    break;
                }
              });
              (() => {})($data);
              this.arr = [];
              this.arr = this.Statistics;
              // (() => {})(this.arr)
            }
          } else if (type == 2) {
            this.clueList = res.data.data.data;
            this.canvasWidth();
            this.funnelCanvas();
          } else {
            this.rateList = res.data.data.data;
          }
        });
    },
    // 跟踪提醒
    getRemindDate(param) {
      storeHome.getRemind(param).then((res) => {
        // this.tryRecordlist = res.data.data.data;
        this.RemindData = res.data.data.data;
        this.RemindDatalen = this.RemindData.length;

        if (this.RemindDatalen != 0) {
          this.RemindData = this.RemindData.slice(0, 5);
        }
        // var keys = [];
        // var Columns = res.data.data.field;
        // if (Columns != undefined) {
        //   Columns.forEach((item, index) => {
        //     var obj = {};
        //     obj.prop = item.fieldname;
        //     obj.label = item.fieldstring;
        //     obj.width = this.columnWidth[index];
        //     if (item.show == "0") {
        //       obj.isShow = false;
        //     } else {
        //       obj.isShow = true;
        //     }
        //     obj.align = "center";
        //     keys.push(obj);
        //   });
        //   this.recordlistColumn = keys;
        //   (() => {})(keys);
        // }
      });
    },
    // 跟踪提醒列表
    getRemindDateList(param) {
      storeHome.getRemind(param).then((res) => {
        this.tryRecordlist = res.data.data.data;
        // this.RemindData = res.data.data.data;
        // this.RemindDatalen = this.RemindData.length;
        var keys = [];
        var Columns = res.data.data.field;
        this.dataNumber = parseInt(res.data.data.allnum);
        if (Columns != undefined) {
          Columns.forEach((item, index) => {
            var obj = {};
            obj.prop = item.fieldname;
            obj.label = item.fieldstring;
            obj.width = this.columnWidth[index];
            if (item.show == "0") {
              obj.isShow = false;
            } else {
              obj.isShow = true;
            }
            if (index == 0) {
              obj.ismethod = true;
            }
            obj.align = "center";
            keys.push(obj);
          });
          this.recordlistColumn = keys;
          (() => {})(keys);
        }
        if (res.data.code !== 200) {
          this.recordoptions.errortip = res.data.msg;
        }
      });
    },
    // 获取职工职工
    getschoolMarketerData() {
      storeHome
        .getschoolMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.schoolList = res.data.data.data;
          this.schoolRateList = res.data.data.data;
          this.schoolClueList = res.data.data.data;
        });
    },
    //  职工筛选
    handleSelect1() {
      this.SelectrateGet(1, this.schoolvalue1);
    },
    handleSelect2() {
      this.SelectrateGet(2, this.schoolvalue2);
    },
    handleSelect3() {
      this.SelectrateGet(3, this.schoolvalue3);
    },
    // 按照关键词查询
    SelectKeyword() {
      this.currentPage = 1;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: this.selectForm.remind_endtime,
        keyword: this.selectForm.keyword,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
      };
      this.getRemindDateList(data);
    },
    // 按照开始时间和结束时间查询
    SelectStarttime() {
      this.currentPage = 1;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: this.selectForm.remind_endtime,
        keyword: this.selectForm.keyword,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
      };
      this.getRemindDateList(data);
    },
    // // 按照结束时间查询
    SelectEndtime() {
      (() => {})(this.selectForm.remind_endtime);
      this.currentPage = 1;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: this.selectForm.remind_endtime,
        keyword: this.selectForm.keyword,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
      };
      this.getRemindDateList(data);
    },
    handClickmore() {
      this.selectForm.remind_starttime = this.$Common.getDate(0);
      this.selectForm.keyword = ""; //数据初始化
      this.currentPage = 1;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: "",
        keyword: "",
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
      };
      this.getRemindDateList(data);
      this.showSliderBox = true;
    },
    canvasWidth() {
      //canvas赋初始值
      let _canvaswidth =
        document.querySelector(".funnel-contain").offsetWidth - 30;
      document.getElementById("myChart-funnel").style.width =
        _canvaswidth + "px";
    },
    funnelCanvas() {
      let myChart = echarts.init(document.getElementById("myChart-funnel"));
      var _data = [];
      for (var i = 0; i < 5; i++) {
        var obj = {};
        switch (i) {
          case 0:
            obj.value = this.clueList.addGrossClient;
            obj.itemStyle = { color: "#62D5A6" };
            obj.name = this.$t("home.bk1");
            break;
          // case 1:
          //   obj.value = this.clueList.addClient;
          //   obj.itemStyle = { color: "#E8CC4D" };
          //   obj.name = this.$t("home.bk");
          //   break;
          case 1:
            obj.value = this.clueList.intentionClient;
            obj.itemStyle = { color: "#64AAFF" };
            obj.name = this.$t("home.bl");
            break;
          case 2:
            obj.value = this.clueList.allInviteClient;
            obj.itemStyle = { color: "#FF8B00" };
            obj.name = this.$t("home.bm");
            break;
          case 3:
            obj.value = this.clueList.auditionClient;
            obj.itemStyle = { color: "#D472EC" };
            obj.name = this.$t("home.bn");
            break;
          // case 4:
          //   obj.value = this.clueList.officialClient;
          //   obj.itemStyle = { color: "#E8CC4D" };
          //   obj.name = this.$t("home.bo");
          //   break;
          case 4:
            obj.value = this.clueList.officialClient;
            obj.itemStyle = { color: "#E8CC4D" };
            obj.name = this.$t("home.bo");
            break;
          default:
            break;
        }
        _data.push(obj);
      }

      (() => {})(_data, "_data");

      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        legend: {
          orient: "horizontal", // 'vertical'
          x: "right",
          icon: "circle",
          itemWidth: 15,
          itemHeight: 15,
          data: this.$t("home.data"),
          // formatter: function (params) {
          //   (() => {})(111111111)
          //   (() => {})(params)
          // }
        },
        calculable: true,
        series: [
          {
            name: "招生转化率",
            type: "funnel",
            width: "40%",
            data: _data,
          },
        ],
      });
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
      this.showLSSliderBoxSee = false;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean() {
      this.$confirm("确认关闭？")
        .then(() => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    handClickName(v) {
      (() => {})(v);
      this.customerId = v.client_id;
      this.isRoot = true;
      this.isTrack = true;
      this.seeSliderTitle = this.$t("home.ax");
      // this.showSliderBoxSee = true;
      this.sId = v.client_id;
      if (v.remind_type == "crm") {
        this.isTrack = false;
        this.showSliderBoxSee = true;
      } else {
        this.isTrack = true;
        this.studentType = v.stuisloss;
        // this.showLSSliderBoxSee = true;
        this.getCrmStudentOneApi(v.client_id);
      }
    },
    handleCheckDesc(v) {
      (() => {})(v);
      this.seeSliderTitle = this.$t("home.gmcRosterPopTitle");
      this.customerId = v.client_id;
      this.isRoot = false;
      this.isTrack = false;
      this.showSliderBoxSee = true;
    },
    // 更多跟踪记录中点击名字
    handleColumnChange(k, v) {
      (() => {})(v);
      this.customerId = v.client_id;
      this.isRoot = true;
      this.isTrack = true;
      // this.showSliderBoxSee = true;
      this.sId = v.client_id;
      if (v.remind_type == "crm") {
        // this.isTrack = false;
        this.showSliderBoxSee = true;
      } else {
        // this.isTrack = false;
        // this.showLSSliderBoxSee = true;
        this.getCrmStudentOneApi(v.client_id);
      }
    },
    getCrmStudentOneApi(sid) {
      storeHome
        .getCrmStudentOneApi({
          student_id: sid,
          marketer_id: this.marketer_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.campusrosterStuData = data;
          this.showLSSliderBoxSee = true;
        });
    },
    // 跟进提交
    onFllowSubmit(v) {
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      v.client_id = this.customerId;
      // if (v.track_followmode != "") {
      storeHome.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          if (this.showSliderBox) {
            let data = {
              marketer_id: this.marketer_id,
              token: this.token,
              company_id: this.company_id,
              school_id: this.school_id,
              remind_starttime: this.selectForm.remind_starttime,
              remind_endtime: this.selectForm.remind_endtime,
              keyword: this.selectForm.keyword,
              is_count: "1", //是否需要总数，可以不传
              p: this.currentPage,
              num: this.pagenum,
            };
            this.getRemindDateList(data);
          } else {
            var currentTime = this.getWeekStartAndEnd(0);
            let data2 = {
              marketer_id: this.marketer_id,
              token: this.token,
              company_id: this.company_id,
              school_id: this.school_id,
              remind_starttime: currentTime[0],
              remind_endtime: currentTime[1],
              keyword: "",
            };
            this.getRemindDate(data2);
          }
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
      // } else {
      //   this.$message({
      //     message: "请选择跟进类型！",
      //     type: "error",
      //   });
      // }
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 查看日程提醒信息
    handSeeEvent(v) {
      this.customerId = v.client_id;
      this.isRoot = true;
      this.isTrack = true;
      this.showSliderBoxSee = true;
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    // tab切换
    addClass: function (index) {
      this.current = index;
      (() => {})(this.current);
      // 招生统计 / 转化 / 转化率
      var $client_endtime, $client_starttime;
      switch (index) {
        case 0:
          $client_starttime = this.$Common.getDate(0);
          $client_endtime = this.$Common.getDate(-7);
          this.$Tool.setStorage("starttime", $client_endtime);
          this.$Tool.setStorage("endtime", $client_starttime);
          $client_starttime = this.$Tool.getStorage("starttime");
          $client_endtime = this.$Tool.getStorage("endtime");
          break;
        case 1:
          $client_starttime = this.$Common.getDate(0);
          $client_endtime = this.$Common.getDate(-30);
          this.$Tool.setStorage("starttime", $client_endtime);
          this.$Tool.setStorage("endtime", $client_starttime);
          $client_starttime = this.$Tool.getStorage("starttime");
          $client_endtime = this.$Tool.getStorage("endtime");
          break;
        default:
          (() => {})("error");
          break;
      }
      if (index != 2) {
        this.staticsFliter.client_starttime = $client_starttime;
        this.staticsFliter.client_endtime = $client_endtime;
        let data = {
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_starttime: $client_starttime,
          client_endtime: $client_endtime,
          from_marketer_id: this.schoolvalue1,
        };
        this.rateGet(data);
        this.showHightTime = false;
        //本周待跟踪提醒
        // let data2 = {
        //   marketer_id: this.marketer_id,
        //   token: this.token,
        //   remind_starttime: $client_starttime,
        //   remind_endtime: $client_endtime,
        //   keyword: ""
        // };
        // this.getRemindDate(data2);
      }
    },
    // tab切换(高级筛选)
    dateClass: function (index) {
      this.current = index;
    },
    // 高级筛选数据请求
    getTimeDate: function () {
      let client_starttime = this.datetime[0];
      let client_endtime = this.datetime[1];
      this.hightTime = client_starttime + "至" + client_endtime;
      this.showHightTime = true;
      this.$Tool.setStorage("starttime", client_starttime);
      this.$Tool.setStorage("endtime", client_endtime);
      this.staticsFliter.client_starttime = client_starttime;
      this.staticsFliter.client_endtime = client_starttime;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        client_starttime: client_starttime,
        client_endtime: client_endtime,
      };
      this.rateGet(data);
      //本周待跟踪提醒
      // let data2 = {
      //   marketer_id: this.marketer_id,
      //   token: this.token,
      //   //假数据
      //   remind_starttime: client_starttime,
      //   remind_endtime: client_endtime,
      //   keyword: ""
      // };
      // this.getRemindDate(data2);
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagenum = val;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: this.selectForm.remind_endtime,
        keyword: this.selectForm.keyword,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagenum,
      };
      this.getRemindDateList(data);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      // this.pagesize=val;
      (() => {})(this.pagenum);
      this.currentPage = val;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        remind_starttime: this.selectForm.remind_starttime,
        remind_endtime: this.selectForm.remind_endtime,
        keyword: this.selectForm.keyword,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagenum,
      };
      this.getRemindDateList(data);
    },
  },
  computed: {
    IsLowerLevel() {
      // 2 为电销权限
      return this.$Tool.getStorage("PostbeCrmlevel") == 2;
    },
    companyIsNoIntention() {
      return this.$store.state.companyIsNoIntention;
    },
  },
};
</script>
<style lang="less">
@import url("home.less");
.home {
  height: 100vh;
  font-size: 20px;
  .top-title-model {
    position: relative;
  }
  .button-fiter:nth-of-type(3) + .el-range-editor--medium.el-input__inner {
    width: 60px;
    position: absolute;
    height: 18px;
    cursor: pointer;
    font-size: 12px !important;
    top: 4px;
    left: 195px;
    opacity: 0;
  }

  .gmc-roster {
    position: relative;
    .filter-box {
      right: 0;
      top: 30px;
      transform: translateY(-50%);
      position: absolute;
      z-index: 10;
    }
    .gmc-roster__tips {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 33px;
      background-color: rgba(40, 171, 217, 0.14980000000000002);
      font-size: 14px;
      color: #28abd9;
      position: relative;
      em {
        margin-right: 10px;
      }
      .el-icon-close {
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        cursor: pointer;
      }
    }

    .resoter-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-height: 750px;
      overflow-y: auto;
      &.el-row {
        padding-bottom: 0;
        border-bottom: none;
        &::before {
          display: none;
        }
      }
      .roster-item {
        width: calc(100% - 8px);
        padding: 12px;
        margin: 0 10px 10px 0;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        &:nth-child(2n) {
          margin-right: 5px;
        }
      }
      .roster-item__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .user {
          display: flex;
          align-items: center;
          img {
            width: 53px;
            height: 53px;
            margin-right: 3px;
            border-radius: 50%;
          }
          span {
            font-size: 14px;
            color: #28abd9;
          }
        }

        .status {
          display: flex;
          align-items: center;
          .status-item {
            padding: 0 8px;
            height: 22px;
            margin-right: 5px;
            line-height: 20px;
            text-align: center;
            border-width: 1px;
            border-style: solid;
            font-size: 12px;
            border-radius: 3px;
            &:last-child {
              margin-right: 0;
            }
          }
          .status-item-grey {
            color: #acacac;
            border-color: #acacac;
          }
          .status-item-green {
            color: #27aad8;
            border-color: #27aad8;
          }
          .status-item-pink {
            color: #ff48bc;
            border-color: #ff48bc;
          }
        }
      }
      .roster-item__desc {
        padding: 10px 0;
        font-size: 14px;
        span {
          color: #28abd9;
        }
      }
      .time {
        font-size: 14px;
        color: rgba(164, 164, 164, 1);
      }
    }
  }
}
</style>
